require('./dist/v-accordion');
module.exports = 'vAccordion';
